
/**
 * @file   参观预约系统介绍页面
 * @create tianmu 2021/2/25
 * @update tianmu 2021/2/25
 */
import React, { useState, useRef, useEffect } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation } from 'react-router-dom';
import { IntroHeader } from '../header';
import { IntroFooter } from '../footer';
import ReactWOW from 'react-wow'
import { localDS } from '../../../storage';
import cls from 'classnames'
import './style.scss'
import { handleFreeTrial } from '../../../utils/productUtils';

/**
 * @description 参观预约系统组件
 */
export const VisitAppointment = () => {
    const [index, setIndex] = useState(1)
    const [tabindex, setTabindex] = useState(1)
    const oDiv = useRef();
    const gnzc = useRef()
    const cptd = useRef()
    const { search } = useLocation()
    const [showTrialTip, setShowTrialTip] = useState(false);
    // 滚动到锚点
    const scrollToAnchor = (anchorName) => {
        setTabindex(anchorName)
        if (anchorName) {
            // 找到锚点
            let anchorElement = document.getElementById(anchorName);
            // 如果对应id的锚点存在，就跳转到锚点
            if (anchorElement) { anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
        }
    }
    useEffect(() => {
        // tab吸顶
        let divT = oDiv.current.offsetTop
        window.onscroll = function () {
            // 获取当前页面的滚动条纵坐标位置 （依次为火狐谷歌、safari、IE678）
            let scrollT = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (scrollT >= divT) {
                if (window.navigator.userAgent.indexOf('MSIE 6.0') != -1) {
                    // 兼容IE6代码
                    // body[0].style.paddingTop = '50px'
                    oDiv.current.style.position = 'absolute';
                    oDiv.current.style.top = scrollT + 'px';
                    oDiv.current.style.left = 0 + 'px';
                } else {
                    // 正常浏览器代码
                    oDiv.current.style.position = 'fixed';
                    oDiv.current.style.top = 0;
                    oDiv.current.style.left = 0;
                }
                document.getElementById('content').style.paddingTop = 50 + 'px'
                for (let i = 0; i < tab.length; i++) {
                    if (scrollT >= document.getElementById(`${i + 1}`)?.offsetTop) {
                        document.getElementById(`link${i + 1}`).classList.add('active');
                        for (let j = 0; j < tab.length; j++) {
                            if (i !== j) {
                                document.getElementById(`link${j + 1}`).classList.remove('active');
                            }
                        }
                    }

                }
            } else {
                oDiv.current.style.position = '';
                document.getElementById('content').style.paddingTop = 0 + 'px'
                for (let j = 0; j < tab.length; j++) {
                    document.getElementById(`link${j + 1}`).classList.remove('active');
                }
            }

        }
        // 其他页面跳转尽量判断是否有锚点
        if (search.split('?')[1]) {
            scrollToAnchor(search.split('?')[1])
        }
    }, [cptd, gnzc, oDiv, search]);
    const tab = ['用户群体', '功能组成', '产品特点', '产品价格', '更新历史']

    return (<>
        <IntroHeader />
        <div className="activity-appointment" id='content'>
            <div className="banner visit">
                <ReactWOW animation="fadeInLeft" duration="1.2s" delay="0.1s">
                    <div className="content">
                        <p className="big">参观预约系统</p>
                        <div className="cont">
                            以满足观众便捷入馆、入园参观体验为核心，为管理人员提供灵活的预约规则配置，让观众通过多种终端完成在线预约，并在入馆入园时快速通过核验，实现参观预约全过程的标准化、数字化、智慧化服务与管理。
                        </div>
                        <div className="btn">
                            {/* <div className="btn1" onClick={() => {
                                const token = localDS.get('saasToken')
                                if (!token) {
                                    window.location.href = "/accountLogin"
                                    return
                                }
                                let a = document.createElement("a"); // 创建一个<a></a>标签
                                a.href = `${window.location.origin}/pdf/visit.pdf`; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
                                a.download = "产品白皮书.pdf"; // 设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
                                a.style.display = "none"; // 障眼法藏起来a标签
                                document.body.appendChild(a); // 将a标签追加到文档对象中
                                a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
                                a.remove(); // 一次性的，用完就删除a标签
                            }}>
                                产品白皮书
                            </div> */}
                            {/* <div className="btn1">
                                观看演示
                            </div> */}
                            <div
                                className="btn2"
                                onClick={handleFreeTrial}
                                onMouseOver={() => { setShowTrialTip(true) }}
                                onMouseLeave={() => { setShowTrialTip(false) }}
                            >
                                免费试用
                                {showTrialTip && <div className='hov'>! 注册并申请机构实名认证后即可免费试用</div>}
                            </div>
                        </div>
                    </div>
                </ReactWOW>
            </div>
            <div className="tab" ref={oDiv}>
                <ul>
                    {tab?.map((item, index) => {
                        return (
                            <li key={index}>
                                <span onClick={() => scrollToAnchor(index + 1)} id={`link${index + 1}`} >{item}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>

            <div className="people" id='1'>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.5s">
                    <p className="title" >用户群体</p>
                </ReactWOW>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.8s">
                    <p className="txt">本产品适用于对观众参观预约有需求的公共文化场馆、文旅景区的社教、宣传部门及相关工作人员。</p>
                </ReactWOW>
            </div>
            <div className="section2" id='2' ref={gnzc}>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="1.1s">
                    <p className="title" id='two'>功能组成</p>
                </ReactWOW>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="1s">
                    <div className="functionof">
                        <div className={cls('item', { active: index === 1 })} onClick={() => { setIndex(1) }}>
                            <div className="moren">
                                <i className='i1' />
                                <p className='tip'>票务管理</p>
                                <p className="txt">预约规则配置</p>
                                <p className="txt">预约观众档案管理</p>
                                <p className="txt">数据统计</p>
                            </div>
                            <div className="activeitem">
                                <p className='top'>
                                    <i className='i1' />
                                    <span className='tip'>票务管理</span>
                                </p>
                                <div className="cont">
                                    为场馆或景区的工作人员和管理者提供灵活的预约规则配置、统一的预约观众档案管理、精准的数据统计分析等功能，从而建立全面的观众大数据模型，便于数据分析、协助决策，提高服务质量。主要功能包括：预约规则配置、预约观众档案管理、数据统计。
                                </div>
                            </div>
                        </div>
                        <div className={cls('item', { active: index === 2 })} onClick={() => { setIndex(2) }}>
                            <div className="moren">
                                <i className='i2' />
                                <p className='tip'>票务预约</p>
                                <p className="txt">微信小程序预约</p>
                                <p className="txt">Web端预约</p>
                            </div>
                            <div className="activeitem">
                                <p className='top'>
                                    <i className='i2' />
                                    <span className='tip'>票务预约</span>
                                </p>
                                <div className="cont">
                                    为观众提供便捷的参观预约服务，支持在微信小程序端、Web端进行门票预约，最大化的为观众提供方便，让观众预约省时、省力、更省心。主要功能包括微信小程序预约和Web端预约。
                                </div>
                            </div>
                        </div>
                        <div className={cls('item', { active: index === 3 })} onClick={() => { setIndex(3) }}>
                            <div className="moren">
                                <i className='i3' />
                                <p className='tip'>票务核验</p>
                                <p className="txt">扫码核销</p>
                                <p className="txt">自助核销</p>
                            </div>
                            <div className="activeitem">
                                <p className='top'>
                                    <i className='i3' />
                                    <span className='tip'>票务核验</span>
                                </p>
                                <div className="cont">
                                    通过扫码核销和自助核销两种方式，为观众、工作人员提供高效的入馆入园核验机制，让观众快速验票，提高入馆入园效率，增强入馆入园体验。主要功能包括扫码核销和自助核销。
                                </div>
                            </div>

                        </div>
                    </div>
                </ReactWOW>
            </div>
            <div className="section3" id='3' ref={cptd}>
                <ReactWOW animation="fadeInUp-little" duration="1s" delay="0.5s">
                    <p className="title">产品特点</p>
                </ReactWOW>
                <div className="section3-box">
                    <ReactWOW animation="fadeInUp-little" duration="1s" delay="0.5s">
                        <div className="item">
                            <div className="itembox">
                                <div className="l">
                                    <i className='icon1' />
                                </div>
                                <div className="r">
                                    <p className="tip">灵活的预约规则配置</p>
                                    <p className='txt'>提供开放时段、预约天数、预约票数、预约须知等预约规则的灵活配置，适应多类型公共场所的开放需求。</p>
                                </div>
                            </div>
                        </div>
                    </ReactWOW>
                    <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.7s">
                        <div className="item">
                            <div className="itembox">
                                <div className="l">
                                    <i className='icon2' />
                                </div>
                                <div className="r">
                                    <p className="tip">全面的预约终端支持</p>
                                    <p className='txt'>提供微信小程序和Web端预约入口，让公众预约更加便捷高效。</p>
                                </div>
                            </div>
                        </div>
                    </ReactWOW>
                    <ReactWOW animation="fadeInUp-little" duration="1s" delay="0.9s">
                        <div className="item">
                            <div className="itembox">
                                <div className="l">
                                    <i className='icon3' />
                                </div>
                                <div className="r">
                                    <p className="tip">快捷多样的验票方式</p>
                                    <p className='txt'>支持扫码核销、自助核销等多种验票方式，方便观众快速通过检票口。</p>
                                </div>
                            </div>
                        </div>
                    </ReactWOW>
                    <ReactWOW animation="fadeInUp-little" duration="1s" delay="1.1s">
                        <div className="item">
                            <div className="itembox">
                                <div className="l">
                                    <i className='icon4' />
                                </div>
                                <div className="r">
                                    <p className="tip">多维度观众统计分析</p>
                                    <p className='txt'>建立观众画像，提供观众预约和入馆入园的多维度统计分析，为观众服务和运营管理提供决策支持。</p>
                                </div>
                            </div>
                        </div>
                    </ReactWOW>
                </div>

            </div>
            <div className="section4" id='4' ref={cptd}>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.5s">
                    <p className="title">产品价格</p>
                </ReactWOW>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.8s">
                    <div className="box">
                        <div className="price">
                            <div className="l">
                                <div className="red">
                                    <span>2800</span>
                                    元/年
                                </div>
                                {/* <span>首年免费</span> */}

                            </div>
                            {/* <div className="buy">立即购买</div> */}
                        </div>

                    </div>
                </ReactWOW>
            </div>
            <div className="update" id='5'>
                <div className="updatebox">
                    更新历史
                    <i className="jian" />
                    <span style={{ marginLeft: 10 }}>2021年9月26日正式发布</span>
                </div>
            </div>
        </div>
        <IntroFooter />
    </>
    )
}
